import { ON_COUNT_UP } from '../state-constants/stateConstants';

export const onCountUp = num => ({
  type: ON_COUNT_UP,
  payload: num,
});



// WEBPACK FOOTER //
// ./src/state-actions/onCountUp.js